import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=c5792012"
import script from "./TagChip.vue?vue&type=script&lang=js"
export * from "./TagChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports